import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { TileModel } from 'theSource/features/Home/types';
import { TileStyled } from './TileStyled';
import { isValidHttpsUrl } from 'theSource/utils';

export const Tile = (tile: TileModel) => {
  const { t } = useTranslation('pages.home');
  const navigate = useNavigate();

  const handleClick = () =>
    isValidHttpsUrl(tile.path!)
      ? window.open(tile.path!, '_blank')
      : navigate(tile.path!);

  return (
    <TileStyled
      data-testid="tile"
      $backgroundImage={tile.backgroundImage}
      onClick={handleClick}
    >
      <Typography variant="label">{t(tile.label)}</Typography>
    </TileStyled>
  );
};
